const Profile = {

    // FIELDS
    "other_details": "Other Details",
    "documents": "Documents",
    "update_profile": "Update Profile",
    "alternate_phone": "Alternate Phone",
    "emergency_phone": "Emergency Phone",
    "emergency_phone_relative": "Emergency Phone Relative",
    "blood_group": "Blood Group",
    "shoe_size": "Shoe Size",
    "tshirt_size": "T-Shirt Size",
    "aadhar": "Aadhaar",
    "pan": "PAN",
    "gst": "GST",
    "view_aadhar": "View Aadhaar Document",
    "view_pan": "View PAN Document",
    "view_gst": "View GST Document",
    "search": "Search Here...",

    "buddies": "Buddies",
    "followers": "Followers",
    "folllowing": "Following",
    "unfollow": "Unfollow",
    "fitness": "Fitness",
    "steps": "Steps",
    "distance": "Distance (m)",
    "last_sync": "Last Sync",

    // TOAST
    "success_unfollow": "Unfollowed Successfully!!..",
    "wrong": "Something went wrong!!..",

    // TOAST
    "success_add": "Profile Updated Successfully!!..",
    "server_error": "Server error!!..",
    "wrong": "Something went wrong!!..",

}

export default Profile;